import { z } from 'zod';

import parseExploreConfigurations from '../parsers/parseExploreConfigurations';

export const citySchema = z.object({
  exploreConfigurations: z
    .array(z.unknown())
    .transform(exploreConfigurations =>
      parseExploreConfigurations(exploreConfigurations)
    )
    .default([])
    .optional(),
  location: z.object({
    country: z.string(),
    countryShort: z.string(),
    district: z.string(),
    districtShort: z.string(),
    lat: z.number(),
    lng: z.number(),
    postalCode: z.coerce.string(),
  }),
  name: z.string(),
  nameShort: z.string(),
  order: z.number().optional(),
  picture: z.string().optional(),
  radius: z.number().nonnegative().optional(),
  timeOffset: z.number().optional(),
  slug: z.string(),
  status: z.string(),
  top: z.boolean().optional(),
  tz: z.string(),
  new: z.boolean().optional(),
  marketplaceSliceSlugs: z.array(z.string()),
});

export type City = z.infer<typeof citySchema>;
